import React from 'react';

import "./Projects.scss";

const Projects : React.FC = () => {
    const baseUrl = `${process.env.PUBLIC_URL}/assets/projects-screenshots/`;
    const data = [
        {
            title: "Rune Todo",
            did: "everything",
            used: "React",
            imageUrl: baseUrl+"rune-todo.png",
            href: "https://maxhha.github.io/rune-todo"
        },
        {
            title: "Tattoo Shop",
            imageUrl: baseUrl+"tattoo-shop.png",
            did: "everything",
            used: "React, Typescript",
            href: "https://maxhha.github.io/tattoo-shop"
        },
        {
            title: "TicTacToe online",
            imageUrl: baseUrl+"tic-tac-toe.png",
            did: "everything, both backend and frontend part",
            used: "React, Typescript, GraphQL, Relay, Express, Apollo Server",
            href: "https://github.com/maxhha/tic-tac-toe-back"
        }
    ];

    return (
        <div className="card-list">
            {data.reverse().map(pr =>
                <ProjectCard
                    {...pr}
                    key={pr.title}
                />
            )}
        </div>
    )
};

type ProjectDescription = {
    title: string,
    imageUrl: string,
    did: string,
    used: string,
    href: string
}

const ProjectCard : React.FC<ProjectDescription> = ({title, imageUrl, did, used, href}) => {
    return (
    <div className="card project-card">
        <a href={href} className="">
            <img
                src={imageUrl}
                className="project-card__image"
                alt={`${title} website`}
            />
        </a>
        <div className="project-card__description">
            <h3>{title}</h3>
            <p><strong>I did</strong> {did}.</p>
            <p><strong>I used</strong> {used}.</p>
        </div>
    </div>)
};

export default Projects;
